import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, catchError, map, of, tap } from "rxjs";
import { ZzzConfigService } from "src/app/zzz/core/config/config.service";
import { ReponseActionApiBase } from "src/app/zzz/core/shared/core.models";
import { SigtHttpClientFactory } from "../http/sigt-http-client-factory.service";

@Injectable({ providedIn: 'root' })
export class SigtUtilisateurService {
  #configService = inject(ZzzConfigService);
  #http = inject(SigtHttpClientFactory).create();

  current: UtilisateurDetails;
  userError: any;

  get urlApi(): string {
    return this.#configService.get().authApiEndPoint;
  }

  obtenirUtilisateurDetails(): Observable<UtilisateurDetails> {
    const url = `${this.urlApi}/sigtapi/utilisateur-details`;
    return this.#http.get<UtilisateurReponse>(url, { withCredentials: true }).pipe(
      catchError(error => {
        this.userError = error;
        return of(null);
      }),
      tap(rep => this.current = rep?.utilisateur),
      map(rep => rep?.utilisateur)
    );
  }

  updateUtilisateur(utilisateurDetails: UtilisateurDetails): Observable<UtilisateurDetails> {
    const url = `${this.urlApi}/sigtapi/utilisateur`;
    return this.#http.post<UtilisateurReponse>(url, { utilisateur: utilisateurDetails }, { withCredentials: true }).pipe(
      tap(rep => this.current = rep.utilisateur),
      map(rep => rep.utilisateur)
    );
  }
}

export interface UtilisateurReponse extends ReponseActionApiBase {
  utilisateur: UtilisateurDetails;
}

export interface UtilisateurDetails {
  id: number;
  code: string;
  prenom: string;
  nom: string;
  courriel: string;
  type: string;
  numeroTelephone: string;
  numeroPoste: string;
  nomMinistereOrganisme: string;
  nomDirection: string;
  typeIntervenant: string;
  estInscrit: boolean;
}
